import { render, staticRenderFns } from "./mpesa.vue?vue&type=template&id=b962be48&"
import script from "./mpesa.vue?vue&type=script&lang=js&"
export * from "./mpesa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports